// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__VxO+Y"};